import React from 'react'
import useTranslation from '../../../../hooks/useTranslation'
import { getTabs } from '../../constants'
import NewMobileIcon from 'assets/svg/new_mobile-phone.svg'
import { AppDownloader } from '@margex/ui'

export const AppDownloaderContainer = () => {
  const { t } = useTranslation()

  const appDownloaderTabs = getTabs(t)

  return <AppDownloader icon={<img src={NewMobileIcon} alt={'Download app'} />} tabs={appDownloaderTabs} />
}
